import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_card from "../../core/service/api_card";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import TabsMobile from "../__template/TabsMobileComponent";
import { useTranslation } from "react-i18next";
import { StatsInvoice } from "../common/home/Stats";
import { BackButton } from "../common/BackButton";

const SyncHistoryWeb = () => {
  const user: User = useAppSelector((state) => state.user.user);

  const [history, setHistory] = useState([]);

  const cardData = JSON.parse(String(localStorage.getItem("card")));

  const navigate = useNavigate();
  const { t } = useTranslation();

  const location = useLocation();

  const { id } = useParams();

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    }
    cardData.map((data: any) => {
      if (data.id == id && data.dateSync) {
        console.log("ketemu");
        setHistory(data.dateSync.reverse());
      }
    });
  }, []);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getCurrency(str: any) {
    return formatCurrency(str).replace(",00", "");
  }

  return (
    <>
      <div className="bg-psp-primary mb-8 font-montserrat">
        <StatsInvoice />
        <div className="h-auto flex bg-psp-primary mt-10">
          <div className="mx-none  container h-full flex-row flex justify-between relative mb-16">
            <div className="flex flex-col rounded-2xl -top-36 relative bg-white items-center py-2  shadow-lg px-8 w-full my-2 mx-1">
              <div className="flex py-2 px-2 w-full relative flex-col bg-white mb-6 ">
                <div className="flex mb-4">
                  <BackButton />
                  <div className="font-bold text-4xl">
                    {t("DIGITALCARD.title")}
                  </div>
                </div>
              </div>
              <section className="mt-1 w-full">
                {history?.map((data: any) => {
                  return (
                    <div key={data} className="bg-white rounded-xl shadow-md font-montserrat border-l-4 border-solid border-l-green-500 mb-2">
                      <div className="flex flex-row px-3 py-3 gap-2 items-center">
                        <div className="w-full flex justify-between">
                          <div className=" text-sm">{user.name}</div>
                          <div className=" text-sm">{data}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!history && <div>{t("DIGITALCARD.emptyHistory")}</div>}
              </section>
            </div>
          </div>
          
        </div>
      </div>
      {/* <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
          <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
            <TabsMobile
              name={`${t("DIGITALCARD.syncHistory")}`}
              backUrl={"digital-card"}
            ></TabsMobile>
          </div>
          <div className="min-h-screen h-full mb-6 px-4 py-2 bg-psp-primary">
            <section className="mt-1">
                {
                    history?.map((data:any) => {
                        return (
                            <div className="bg-white rounded-xl shadow-md font-montserrat border-l-4 border-solid border-l-green-500 mb-2">
                                <div className="flex flex-row px-3 py-3 gap-2 items-center">
                                    <div className="w-full flex justify-between">
                                        <div className=" text-sm">
                                            {user.name}
                                        </div>
                                        <div className=" text-sm">
                                            {data}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    !history && <div>{t("DIGITALCARD.emptyHistory")}</div>
                }
            </section>
          </div>
        </div> */}
    </>
  );
};

export default SyncHistoryWeb;
